<template>
  <div>

    <div class="row">
      <div class="col-12">
        <card type="chart">
          <template slot="header">
            <div class="row">
              <div class="col-sm-6 text-left" >
                <h5 class="card-category">{{ $t('dashboard.totalTopics') }}</h5>
                <h2 class="card-title">{{ $t('dashboard.performance') }}</h2>
              </div>
              <div class="col-sm-6">
                <div
                  class="float-right btn-group btn-group-toggle"
                  data-toggle="buttons">
                  <label
                    v-for="eachCategory in CategoryList"
                    :key="eachCategory.id"
                    :class="{active: activeTopicCategoryId == eachCategory.id}"
                    :id="eachCategory.id"
                    class="btn btn-sm btn-primary btn-simple">
                    <input
                      :checked="activeTopicCategoryId == eachCategory.id"
                      type="radio"
                      name="options"
                      autocomplete="off"
                      @click="activeTopicCategoryId = eachCategory.id">
                    {{ eachCategory.name }}
                  </label>
                </div>
              </div>
            </div>
          </template>
          <div class="chart-area">
            <line-chart
              ref="bigChart"
              :chart-data="bigLineChart.chartData"
              :gradient-colors="bigLineChart.gradientColors"
              :gradient-stops="bigLineChart.gradientStops"
              :extra-options="bigLineChart.extraOptions"
              style="height: 100%"
              chart-id="big-line-chart"/>
          </div>
        </card>
      </div>
    </div>
    <div
      v-show="false"
      class="row">
      <div
        :class="{'text-right': true}"
        class="col-lg-4">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{ $t('dashboard.totalShipments') }}</h5>
            <h3 class="card-title"><i class="tim-icons icon-bell-55 text-primary "/> 763,215</h3>
          </template>
          <div class="chart-area">
            <line-chart
              :chart-data="purpleLineChart.chartData"
              :gradient-colors="purpleLineChart.gradientColors"
              :gradient-stops="purpleLineChart.gradientStops"
              :extra-options="purpleLineChart.extraOptions"
              style="height: 100%"
              chart-id="purple-line-chart"/>
          </div>
        </card>
      </div>
      <div
        :class="{'text-right': true}"
        class="col-lg-4">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{ $t('dashboard.dailySales') }}</h5>
            <h3 class="card-title"><i class="tim-icons icon-delivery-fast text-info "/> 3,500€</h3>
          </template>
          <div class="chart-area">
            <bar-chart
              :chart-data="blueBarChart.chartData"
              :gradient-stops="blueBarChart.gradientStops"
              :extra-options="blueBarChart.extraOptions"
              style="height: 100%"
              chart-id="blue-bar-chart"/>
          </div>
        </card>
      </div>
      <div
        :class="{'text-right': true}"
        class="col-lg-4">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{ $t('dashboard.completedTasks') }}</h5>
            <h3 class="card-title"><i class="tim-icons icon-send text-success "/> 12,100K</h3>
          </template>
          <div class="chart-area">
            <line-chart
              :chart-data="greenLineChart.chartData"
              :gradient-stops="greenLineChart.gradientStops"
              :extra-options="greenLineChart.extraOptions"
              style="height: 100%"
              chart-id="green-line-chart"/>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <card
          :header-classes="{'text-right': true}"
          type="tasks">
          <template slot="header">
            <h6 class="title d-inline">{{ $t('dashboard.tasks', {count: 5}) }}</h6>
            <p class="card-category d-inline">{{ $t('dashboard.today') }}</p>
            <base-dropdown
              :class="{'float-left': true}"
              menu-on-right=""
              tag="div"
              title-classes="btn btn-link btn-icon"
              aria-label="Settings menu">
              <i
                slot="title"
                class="tim-icons icon-settings-gear-63"/>
              <a
                class="dropdown-item"
                href="#">{{ $t('dashboard.dropdown.action') }}</a>
              <a
                class="dropdown-item"
                href="#">{{ $t('dashboard.dropdown.anotherAction') }}</a>
              <a
                class="dropdown-item"
                href="#">{{ $t('dashboard.dropdown.somethingElse') }}</a>
            </base-dropdown>
          </template>
          <div class="table-full-width table-responsive">
            <task-list/>
          </div>
        </card>
      </div>
      <div class="col-lg-6 col-md-12">
        <card class="card">
          <h4
            slot="header"
            class="card-title">{{ $t('dashboard.simpleTable') }}</h4>
          <div class="table-responsive">
            <user-table/>
          </div>
        </card>
      </div>
    </div>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-btn
        flat
        @click="snack = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import LineChart from '@/components/Charts/LineChart'
import BarChart from '@/components/Charts/BarChart'
import * as chartConfigs from '@/components/Charts/config'
import TaskList from '@/pages/Dashboard/TaskList'
import UserTable from '@/pages/Dashboard/UserTable'
import config from '@/config'
import axios from 'axios'

export default {
  components: {
    LineChart,
    BarChart,
    TaskList,
    UserTable
  },
  data () {
    return {
      snack: false,
      snackColor: '',
      snackText: '',
      activeTopicChart: {
        id: '',
        name: ''
      },
      activeTopicCategoryId: 'houses',
      CategoryList: [],
      allTopics: [],
      activeCategoryTopics: [],
      bigLineChart: {
        allData: [
          [100, 70, 90, 70, 85, 60, 75, 60, 90, 80, 110, 100],
          [80, 120, 105, 110, 95, 105, 90, 100, 80, 95, 70, 120],
          [60, 80, 65, 130, 80, 105, 90, 130, 70, 115, 60, 130]
        ],
        activeIndex: 0,
        chartData: {
          datasets: [{ }],
          labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: []
      },
      purpleLineChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          datasets: [{
            label: 'Data',
            fill: true,
            borderColor: config.colors.primary,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: config.colors.primary,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: config.colors.primary,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: [80, 100, 70, 80, 120, 80]
          }]
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0]
      },
      greenLineChart: {
        extraOptions: chartConfigs.greenChartOptions,
        chartData: {
          labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV'],
          datasets: [{
            label: 'My First dataset',
            fill: true,
            borderColor: config.colors.danger,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: config.colors.danger,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: config.colors.danger,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: [90, 27, 60, 12, 80]
          }]
        },
        gradientColors: ['rgba(66,134,121,0.15)', 'rgba(66,134,121,0.0)', 'rgba(66,134,121,0)'],
        gradientStops: [1, 0.4, 0]
      },
      blueBarChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ['USA', 'GER', 'AUS', 'UK', 'RO', 'BR'],
          datasets: [{
            label: 'Countries',
            fill: true,
            borderColor: config.colors.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [53, 20, 10, 80, 100, 45]
          }]
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0]
      }
    }
  },
  computed: {
    enableRTL () {
      return this.$route.query.enableRTL
    }
  },
  watch: {
    activeTopicCategoryId: function (newVal) {
      this.activeCategoryTopics = this.allTopics.filter(x => x.category_id === newVal)
      this.initBigChart()
    }
  },
  mounted () {
    this.getAllTopics()
    this.getCategories()
    this.i18n = this.$i18n
  },
  methods: {
    getAllTopics () {
      this.$store.state.spinning = true
      let self = this
      axios.get('/stats/topics')
        .then(response => {
          self.allTopics = response.data
          self.$store.state.spinning = false
        })
        .catch(err => {
          if (err.response && err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response))
          }
          self.$store.state.spinning = false
          // console.log(JSON.stringify(err.response))
        })
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    getCategories () {
      this.$store.state.spinning = true
      let self = this
      axios.get('/categories')
        .then(response => {
          self.CategoryList = response.data
          if (self.CategoryList.length !== 0) {
            this.activeTopicCategoryId = self.CategoryList[0].id
          }
          self.$store.state.spinning = false
        })
        .catch(err => {
          if (err.response && err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            console.log('/categories')
            this.showError(JSON.stringify(err.response))
          }
          self.$store.state.spinning = false
          // console.log(JSON.stringify(err.response))
        })
    },
    initBigChart () {
      let chartData = {
        datasets: [{
          fill: true,
          borderColor: config.colors.primary,
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: config.colors.primary,
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: config.colors.primary,
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: this.activeCategoryTopics.map(x => x.count),
          options: {
            maintainAspectRatio: false
          }
        }],
        labels: this.activeCategoryTopics.map(x => x.month)
        // labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
      }
      this.$refs.bigChart.updateGradients(chartData)
      this.bigLineChart.chartData = chartData
    }
  }
}
</script>
<style>
</style>
